// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"BackdropSpinner_Backdrop__11a-M","BackdropSpinner":"BackdropSpinner_BackdropSpinner__2weWA"};